import { CollectionsApiClient } from '@fourthwall/services/dist/CollectionsApiClient'
import { createQueryHook } from '@fourthwall/utils'
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize'

export const useCollection = createQueryHook(CollectionsApiClient.getCollection, {
  queryKey: ['collection'],
  select: (data) => {
    data.name = decodeHtmlEntities(data.name)

    return data
  },
})
